import { Pipe, PipeTransform } from '@angular/core';

/**
 * 日付文字列成形パイプ(年月)
 * 「yyyyMM」から形式変換。
 * @export
 * @class DateStringPipe
 * @implements {PipeTransform}
 */
@Pipe({
  name: 'dateYmStringSg',
})
export class DateYmStringSgPipe implements PipeTransform {

  /**
   * 日付文字列を受け取り、整形する
   *
   * @param {string} date
   * @return {*}  {string}
   * @memberof DateStringPipe
   */
  transform(date: string): string {
    let formattedDate: string = '';
    if (date && date != '') {
      formattedDate = date.substr(0, 4) + '年' + date.substr(4, 2) + '月';
    }
    return formattedDate;
  }
}
